import React from "react";
import { T } from "../theme";

// Shared status pill — used by the Progress tab steps and the finance
// coaching toggles. Moved verbatim from ClientPage.js in the module refactor.
export const STATUS_KEYS = ["to-start", "in-progress", "complete"];
export const STATUS_CONFIG = {
  "to-start":    { label: "To start",     color: T.fgMuted, bg: T.bgNeutral, activeBg: T.canopy,   activeColor: T.root },
  "in-progress": { label: "In progress",  color: T.fgMuted, bg: T.bgNeutral, activeBg: T.threadline, activeColor: T.root },
  "complete":    { label: "Complete",      color: T.fgMuted, bg: T.bgNeutral, activeBg: T.statusOn, activeColor: T.canvas },
};

export function StatusPill({ status, onChange }) {
  return (
    <div style={{ display: "inline-flex", borderRadius: T.radiusPill, overflow: "hidden", border: `1px solid ${T.borderSubtle}`, background: T.bgNeutral }}>
      {STATUS_KEYS.map(key => {
        const sc = STATUS_CONFIG[key];
        const active = status === key;
        return (
          <button key={key} onClick={() => onChange(key)} style={{
            padding: "4px 12px", fontSize: 10, fontWeight: 600, border: "none", cursor: "pointer",
            fontFamily: T.fontSans, letterSpacing: "0.02em", transition: "all 0.15s",
            background: active ? sc.activeBg : "transparent", color: active ? sc.activeColor : sc.color,
          }}>{sc.label}</button>
        );
      })}
    </div>
  );
}
